module.exports = __webpack_public_path__ + "img/menu-icon.b6995acb.svg";